import React, { useEffect, useState } from 'react';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import axios from 'axios';
import {flatObject} from '../../../utils/flat';
import SeasonRecordComponent from '../../../components/record/SeasonRecordComponent';
import {useCookies} from 'react-cookie';
import dateSetting from '../../../utils/dateSetting';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import ballImage from '../../../assets/img/icon/ball_icon.png';

function PlayerBasicData({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [profileObj, setProfileObj] = useState({});

    const { t } = useTranslation();
    let useLang = localStorage.getItem("language");
    
    useEffect(() => {
        const season = new Date().getFullYear();
        let playerId = profile['playerId'];
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                batterIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            let {batter, pitcher} = result['data']['result'][0];
            let flatResult = {
                ...batter, ...pitcher
            }
            
            setProfileObj(flatResult);
        })
    }, []);

    // function onErrorHandler(event) {
    //     event.target.src = NullPlayer;
    // }

    if(Object.keys(profileObj).length === 0 ) {
        return <DefaultLoader />
    }

    return (
        <div className="profileDataBox">
            <div className="dataTitle">
                <img src={ballImage} style={{ height: '25px'}} alt='#'/>
                {t('profile')}
            </div>
            <div className="recordBox" style={{fontSize: 13, fontWeight: 500}}>
                <Row>
                    <Col md={5}>{t('dateOfBirth')}</Col>
                    <Col md={7}>{profileObj['birthdate']}</Col>
                </Row>
                <Row>
                    <Col md={5}>{t('height')}</Col>
                    <Col md={7}>{profileObj['height']}cm</Col>
                </Row>
                <Row>
                    <Col md={5}>{t('weight')}</Col>
                    <Col md={7}>{profileObj['weight']}kg</Col>
                </Row>
            </div>
        </div>
    )
}

export default PlayerBasicData;